document.addEventListener("DOMContentLoaded", function () {
  (function ($) {
    $(function () {
      const shopifyAccessToken =
        Shopify.shop === "petsense-dev.myshopify.com"
          ? "968d01c50b5df693e1a23a58599ccece"
          : "7a5b25147ab7ed3c91b96b126ccacdf1";

      const locationSyncData = document.querySelector("[data-location-sync]")
        ?.innerHTML
        ? JSON.parse(document.querySelector("[data-location-sync]").innerHTML)
        : null;

      const GADGET_URL =
        locationSyncData?.location_sync_gadget_app_url ||
        "https://ps-inventory-sync.gadget.app";

      const cartInformation = document.querySelector("[data-cart-information]")
        ?.innerHTML
        ? JSON.parse(
            document.querySelector("[data-cart-information]").innerHTML
          )
        : null;

      const {
        has_pickup_items,
        has_mixed_items,
        has_sameday_delivery,
        has_shipped_items,
        item_skus,
        cart_items,
        product_variants,
      } = cartInformation;

      let selectedLocation;
      if (has_pickup_items && !has_mixed_items) {
        selectedLocation = JSON.parse(
          localStorage.getItem("locationSelection")
        );
      } else if (has_sameday_delivery && !has_mixed_items) {
        selectedLocation = JSON.parse(
          localStorage.getItem("deliverySelection")
        );
      }

      const CART_DATA = {
        attributes: {
          pickupID: "",
          shipType: "",
          address1: "",
          address2: "",
          city: "",
          state: "",
          zip: "",
          name: "",
          loc_phone: "",
          defaultorderstatus: "",
          subscriptionOrder: false,
          "Checkout-Method": "",
          "Delivery-Date": "",
          "Delivery-Location-Id": "",
          "Delivery-Slot-Id": "",
          "Delivery-Time": "",
          storeid: "",
          location_id: "",
          storeid: "",
        },
      };

      /**
       * DeliveryMethodMutation to pre-select the delivery method to pick up and set the store for pick up
       */
      const getDeliveryMethodMutation = (
        cartToken,
        deliveryMethod,
        locationGID
      ) => `
          mutation UpdateBuyerIdentity {
            cartBuyerIdentityUpdate(
              cartId: "gid://shopify/Cart/${cartToken}",
              buyerIdentity: {
                countryCode: US,
                deliveryAddressPreferences: [],
                preferences: {
                  delivery: {
                    deliveryMethod: ${deliveryMethod}
                    pickupHandle: "${locationGID}"
                  }
                }
              }
            ) {
              cart {
                id
                buyerIdentity {
                  countryCode
                  deliveryAddressPreferences {
                    ... on MailingAddress {
                      address1
                      address2
                      firstName
                      lastName
                      country
                      province
                      city
                    }
                  }
                  preferences {
                    delivery {
                      deliveryMethod
                      pickupHandle
                    }
                  }
                }
              }
            }
          }
        `;

      /** Storefront GraphQL API Query */
      const fetchGraphQL = async (query) => {
        const url = `https://${window.Shopify.shop}/api/2024-07/graphql.json`;
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": shopifyAccessToken,
          },
          body: JSON.stringify({ query: query }),
        });
        return response.json();
      };

      /** Fetch the cart token then update cart preferences to set default shipping method to BOPIS */
      const fetchCartToken = async (deliveryMethod, locationGID) => {
        try {
          const response = await fetch("/cart.js", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          });

          if (!response.ok) {
            console.error("Error Getting Cart Token: ", response.statusText);
          }

          const cart = await response.json();
          const cartToken = cart.token;
          updateCartPreferences(cartToken, deliveryMethod, locationGID);
        } catch (error) {
          console.error("Error Fetching Cart Token: ", error);
        }
      };

      const updateCartPreferences = async (
        cartToken,
        deliveryMethod,
        locationGID
      ) => {
        const mutation = getDeliveryMethodMutation(
          cartToken,
          deliveryMethod,
          locationGID
        );
        try {
          const response = await fetchGraphQL(mutation);
          if (response.errors) {
            console.error("GraphQL Errors: ", response.errors);
          }
        } catch (error) {
          console.error("Error Updating Buyer Preferences: ", error);
        }
      };

      const allowCheckout = () => {
        /** Wrapped in a setTimeout to push this action to the bottom of the execution stack */
        setTimeout(() => {
          $("#checkout-buttons").removeClass("checkout-disabled");
        }, 0);
      };

      /**
       * AJAX call to update cart attributes
       * Used to reset cart attributes for all shipping methods (BOPIS, Local Delivery, Ship to home)
       */
      const updateCartAttributes = (attributes) => {
        $.ajax({
          url: "/cart/update.js",
          data: attributes,
          method: "POST",
          dataType: "json",
        });
      };

      /** Used to check item inventory levels for BOPIS/Local Delivery */
      const checkLocationInventory = async (productVariants, locationId) => {
        fetch(
          `${GADGET_URL}/inventory/stock?productVariants=${productVariants}&locationId=${locationId}`
        )
          .then((res) => res.json())
          .then((data) => {
            let canCheckout = true;

            /** If no inventory is returned, hide checkout buttons */
            if (data.length <= 0) {
              $(".cart-store-selection .banner:first-child")
                .removeClass("banner--info")
                .addClass("banner--warning")
                .html(
                  "Some items are not available for pickup at this store. Please choose a different store.</a>."
                );
              $("#checkout-buttons").hide();
              return;
            }

            /** Check all quantities of all items in the cart */
            for (const inventoryItem of data) {
              const sku = inventoryItem?.sku;
              const inventoryStock = inventoryItem?.available;

              const itemCanCheckout = handleQuantitySelectors(
                sku,
                inventoryStock
              );

              if (!itemCanCheckout) {
                canCheckout = false;
                break;
              }
            }

            canCheckout && allowCheckout();
          });
      };

      const handleQuantitySelectors = (sku, inventoryStock) => {
        let canCheckout = true;
        const cartQtyWrapper = document.querySelector(`.item-qty-${sku}`);
        const qtyInput = cartQtyWrapper.querySelector(".cart-qty-input");
        const qtyStockMessage = cartQtyWrapper.querySelector(
          ".item-qty__stock-message"
        );
        const qtyErrorMessage = cartQtyWrapper.querySelector(
          ".item-qty__error-message"
        );

        /** Set the max quantity */
        qtyInput.max = inventoryStock;
        /** Disable the plus button if the current stock is the same as qtyInput.value */
        cartQtyWrapper.querySelector(".qtyplus").disabled =
          qtyInput.value >= inventoryStock;

        if (qtyInput.value > inventoryStock) {
          qtyStockMessage.innerHTML = `In Stock: ${inventoryStock}`;
          qtyErrorMessage.innerHTML = `You've selected more than the maximum available quantity`;
          qtyErrorMessage.classList.remove("hidden");
          canCheckout = false;
          return canCheckout;
        }

        /** If product is out of stock, show error message and return */
        if (inventoryStock < qtyInput.value) {
          qtyErrorMessage.innerHTML = `This product is out of stock, please remove from the cart`;
          qtyErrorMessage.classList.remove("hidden");
          canCheckout = false;
          return canCheckout;
        }

        /** If the current quantity is the same as the inventory stock, display the default message */
        if (qtyInput.value >= inventoryStock) {
          qtyErrorMessage.classList.remove("hidden");
        } else {
          qtyStockMessage.innerHTML = "";
        }

        return canCheckout;
      };

      /** Used to check item inventory levels for only ship to home */
      const checkSFSInventory = async (productVariants) => {
        /**
         * If NO Product Variants, return
         */
        if (!productVariants.length) {
          return;
        }
        let canCheckout = true;

        /** Fetch EA stock for all productVariants in the cart */
        const sfsInventory = await fetch(
          `${GADGET_URL}/sfs/stock?productVariants=${productVariants}`
        )
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! Status: ${res.status}`);
            }
            return res.json();
          })
          .then((data) => data);

        /** If no EA inventory is returned, return */
        if (!sfsInventory?.length) {
          return;
        }

        for (const inventoryItem of sfsInventory) {
          const sku = inventoryItem?.sku;
          const inventoryStock = inventoryItem?.available;

          const itemCanCheckout = handleQuantitySelectors(sku, inventoryStock);

          if (!itemCanCheckout) {
            canCheckout = false;
            break;
          }
        }

        canCheckout && allowCheckout();
      };

      /** Ship to home cart validations & checks */
      if (has_shipped_items && !has_pickup_items && !has_sameday_delivery) {
        // check cart items if selling_plan_allocation exists (subscription)
        const cartDataCopy = { ...CART_DATA };
        cartDataCopy.attributes.shipType = "shipping";
        cartDataCopy.attributes.defaultorderstatus = "UnConfirmed";
        const foundObject = cart_items.find(
          (obj) => "selling_plan_allocation" in obj
        );
        if (foundObject && Object.values(foundObject)?.length) {
          cartDataCopy.attributes.subscriptionOrder = true;
        }
        updateCartAttributes(cartDataCopy);

        /** Check all ship to home items inventory stock from SFS Bucket */
        checkSFSInventory(product_variants);

        /** BOPIS cart validations & checks */
      } else if (
        has_pickup_items &&
        !has_shipped_items &&
        !has_sameday_delivery
      ) {
        if (selectedLocation) {
          const locationSelection = localStorage.getItem("locationSelection");
          let locationId;
          let locationGID;
          let distributionCenterId;

          if (locationSelection) {
            locationId = JSON.parse(locationSelection).name.split(" - ")[0];
            locationGID = JSON.parse(locationSelection).id;
            distributionCenterId =
              JSON.parse(locationSelection).distributionCenterId;
          }

          /** Set the cart attributes for orderbot to route the order */
          const cartDataCopy = { ...CART_DATA };
          cartDataCopy.attributes = {
            pickupID: distributionCenterId,
            address1: selectedLocation?.address1,
            address2: selectedLocation?.address2,
            shipType: "pickup",
            city: selectedLocation?.city,
            state: selectedLocation?.province,
            zip: selectedLocation?.zipCode,
            name: selectedLocation.name,
            loc_phone: selectedLocation?.phone,
            defaultorderstatus: "UnConfirmed",
            storeid: selectedLocation.name.split("-")[0].trim(),
            location_id: selectedLocation.name.split("-")[0].trim(),
          };

          /** immediately update cart to correct ship type */
          updateCartAttributes(cartDataCopy);

          /** Check cart inventory if any of the skus for distribution ID are available */
          checkLocationInventory(product_variants, locationGID);
        }
      }

      /** Custom Zapiet Integration for same day delivery */
      if (window.Zapiet) {
        /** Initial load, change zapiet button text and force click same day delivery */
        window.ZapietEvent.listen("widget_loaded", () => {
          const zapietApp = document.querySelector("#storePickupApp");
          zapietApp.classList.add("hidden");
          setTimeout(() => {
            if (has_sameday_delivery && !has_mixed_items) {
              document.querySelector(".checkoutMethod").click();
            }
          }, 500);

          if (has_sameday_delivery && !has_mixed_items) {
            zapietApp.classList.remove("hidden");
          }
        });

        /** When same day delivery is forced clicked, run all the validations after delivery note has been */
        window.ZapietEvent.listen("selected_method", (checkout_method) => {
          const bopisButton = document.querySelector(".bopis-button");
          const deliverySummary = document.querySelector(".delivery_summary");
          const cartStoreSelection = document.querySelector(
            ".cart-store-selection"
          );

          if (has_sameday_delivery && !has_mixed_items) {
            /**
             * Wait for zapiet delivery note to be rendered
             * After it has been rendered, set the delivery postcode and set the location ID to the hidden zapiet field
             */
            const waitForDeliveryNote = async () => {
              if ($(".delivery_note").length > 0) {
                clearInterval(checkForDeliveryNote);
                Zapiet.setDeliveryPostcode(selectedLocation?.zipCode);
                const zapietId = selectedLocation?.zapietId;
                const locationId = selectedLocation?.name?.split("-")[0].trim();
                if (!zapietId) {
                  return;
                }

                deliveryFilterByValue.value = zapietId;

                const cartDataCopy = { ...CART_DATA };
                cartDataCopy.attributes = {
                  pickupID: selectedLocation?.distributionCenterId,
                  address1: selectedLocation?.address1,
                  address2: selectedLocation?.address2,
                  shipType: "Roadie",
                  city: selectedLocation?.city,
                  state: selectedLocation?.province,
                  zip: selectedLocation?.zipCode,
                  name: selectedLocation?.name,
                  loc_phone: selectedLocation?.phone,
                  defaultorderstatus: "UnConfirmed",
                  storeid: locationId,
                  location_id: locationId,
                };

                updateCartAttributes(cartDataCopy);

                checkLocationInventory(product_variants, selectedLocation.id);
              }
            };
            const checkForDeliveryNote = setInterval(waitForDeliveryNote, 1000);

            if (checkout_method === "delivery") {
              if (cartStoreSelection) {
                cartStoreSelection.classList.add("hidden");
              }
              deliverySummary.classList.remove("hidden");

              if (bopisButton) {
                bopisButton.classList.remove("active");
              }
            }
          }
        });
      }

      /** set URL of 'continue shopping' link with History state if we have it */
      if (window.history && window.history.length) {
        $("#continue-shopping").on("click", function (e) {
          e.preventDefault();
          history.back();
        });
      }

      /** On cart form submission */
      window.submitForm = async function (e) {
        e.preventDefault();
        const bopisButton = document.querySelector(".bopis-button");
        const zapietApp = document.querySelector("#storePickupApp");
        const isZapietHidden =
          zapietApp && zapietApp.classList.contains("hidden");
        const isBopisActive =
          bopisButton && bopisButton.classList.contains("active");

        const locationSelection = localStorage.getItem("locationSelection");
        let locationGID;

        /** If BOPIS is active, fetch cart token and set pre-select to pick up */
        if (locationSelection && isBopisActive) {
          locationGID = JSON.parse(locationSelection).id;
          const locationId = locationGID?.split("/").pop();
          await fetchCartToken("PICK_UP", locationId);

          /** Set a timeout, to push this action to the bottom of the execution stack */
          setTimeout(() => {
            window.location = "/checkout";
          }, 1000);
        } else if (isZapietHidden) {
          /** Override the window.location because zapiet blocks it (Ship to home orders) */
          window.location = "/checkout";
        }
      };
    });
  })(jQuery);
});
